import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import {EditPermissions} from "../../../../../../../shared/models";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {getEditTypes} from "../../../delegatorUtils";
import {required} from "../../../../../../../shared/utils";

export const NODE_TYPE = "menuOption";

interface MenuOptionData {
    menuHeader: string
    imageRef: string
    bodyText: string
    groupTitle: string
    displayTypes: {}
    customListButton: string
    optionSeperator: string
    defaultNext: string
    options: OptionsData[]
}

interface OptionsData {
    imageRef: string
    bodyText: string
    text: string
    next: string
    keywords: []
}

export class MenuOption {

    private menu: {} = {};

    constructor() {
        this.menu = {
            'menuType': NODE_TYPE,
        };
    }

    public static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): FormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        const formData: MenuOptionData = this.getFromData(stepData);

        return this.buildForm(formData, editFlows);
    }

    private static getFromData(stepData: { [index: string]: any }): MenuOptionData {

        const menu = stepData?.menu ? stepData?.menu : {};
        const options = menu?.options ? menu?.options : {};
        const menuParams = menu?.menuParams ? menu?.menuParams : {};
        const result = menu?.result ? menu?.result : {};
        const defaultNext = result?.default ? result?.default : {};

        return {
            menuHeader: menu?.menuHeader ? menu?.menuHeader : "",
            imageRef: menu?.imageRef ? menu?.imageRef : "",
            bodyText: menu?.bodyText ? menu?.bodyText : "",
            groupTitle: menuParams?.groupTitle ? menuParams?.groupTitle : "",
            displayTypes: menuParams?.displayTypes ? menuParams?.displayTypes : {},
            customListButton: menuParams?.customListButton ? menuParams?.customListButton : "",
            optionSeperator: options?.optionSeperator ? options?.optionSeperator : ". ",
            defaultNext: defaultNext?.next ? defaultNext?.next : "OPTIONAL",
            options: this.OptionToArray(options),
        };
    }

    private static buildForm(formData: MenuOptionData, editFlows: boolean): FormGroup {
        return new FormGroup({
            menuHeader: new FormControl({
                value: formData.menuHeader,
                disabled: !editFlows
            }),
            imageRef: new FormControl({
                value: formData.imageRef,
                disabled: !editFlows
            }),
            bodyText: new FormControl({
                value: formData.bodyText,
                disabled: !editFlows
            }, required('Body text')),
            groupTitle: new FormControl({
                value: formData.groupTitle,
                disabled: !editFlows
            }),
            displayTypes: this.buildDisplayTypesForm(new FormGroup({}), formData.displayTypes),
            customListButton: new FormControl({
                value: formData.customListButton,
                disabled: !editFlows
            }),
            optionSeperator: new FormControl({
                value: formData.optionSeperator,
                disabled: !editFlows
            }),
            defaultNext: new FormControl({
                value: formData.defaultNext,
                disabled: !editFlows
            }),
            options: this.buildOptionsForm(formData.options, editFlows)
        });
    }

    public static optionTemplate(optionsData: OptionsData, editFlows: boolean): FormGroup {
        return new FormGroup({
            bodyText: new FormControl({
                value: optionsData.bodyText,
                disabled: !editFlows
            }),
            imageRef: new FormControl({
                value: optionsData.imageRef,
                disabled: !editFlows
            }),
            text: new FormControl({
                value: optionsData.text,
                disabled: !editFlows
            }, required('Option')),
            next: new FormControl({
                value: optionsData.next,
                disabled: !editFlows
            }),
            keywords: new FormArray(optionsData.keywords),

        });
    }

    public static buildDisplayTypesForm( displayTypesForm: FormGroup, displayTypes: {}): FormGroup {
        if (displayTypes) {
            for (const channelId in displayTypes) {
                const displayTypeValue = displayTypes[channelId]
                if (displayTypesForm.get(channelId)) {
                    displayTypesForm.get(channelId).setValue(displayTypeValue)
                } else {
                    displayTypesForm.addControl(channelId, new FormControl(displayTypeValue));
                }
            }
        }

        return displayTypesForm;
    }
    private static buildOptionsForm(options: OptionsData[], editFlows: boolean): FormArray {

        const optionsForm = new FormArray([]);

        for (let option of options) {
            optionsForm.push(this.optionTemplate(option, editFlows))
        }

        return optionsForm;
    }

    private static OptionToArray(options: { [index: string]: any }): OptionsData[] {

        const items = options?.items ? options?.items : {};

        if (Object.keys(items).length < 1) {
            return [{
                next: newStepValue,
                bodyText: "",
                imageRef: "",
                text: "",
                keywords: []
            }];
        }

        const keywords = options?.keywords ? options?.keywords : {}
        const optionsData: OptionsData[] = []

        for (let item in items) {
            const {imageRef, bodyText, text, next} = items[item];
            const keyword = keywords[item];
            optionsData.push({
                text,
                imageRef,
                bodyText,
                next,
                keywords: keyword
            });
        }

        return optionsData;
    }


    get nodeData(): {} {
        return {
            menu: this.menu,
            'type': 'menu',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }


    setNodeData(nodeData: MenuOptionData) {

        const {
            menuHeader,
            imageRef,
            bodyText,
            groupTitle,
            displayTypes,
            customListButton,
            optionSeperator,
            defaultNext,
            options,
        } = nodeData

        const {items, keywords}: any = options.map((option): { items: any, keywords: any } => {

            const {imageRef, bodyText, text, next, keywords} = option;

            const items = {
                imageRef,
                bodyText,
                text,
                next,
            };

            return {items, keywords}
        }).reduce((previousValue, currentValue, currentIndex) => ({
            items: {
                ...previousValue['items'],
                [currentIndex + 1]: currentValue.items
            },
            keywords: {
                ...previousValue['keywords'],
                [currentIndex + 1]: currentValue.keywords
            }
        }), {})


        const menuParams = {
            groupTitle,
            displayTypes,
            customListButton,
        }

        const option = {
            optionSeperator,
            items,
            keywords
        };

        const results = {
            default: {
                next: defaultNext,
            },
        }

        this.menu = {
            ...this.menu,
            menuHeader,
            imageRef,
            bodyText,
            menuParams,
            options: option,
            results
        }
    }

}


//{
//     "menu": {
//         "menuType": "menuOption",
//         "menuHeader": "",
//         "imageRef": "",
//         "bodyText": "",
//         "menuParams": {
//             "groupTitle": "",
//             "displayType": "",
//             "displayTypes": {},
//             "customListButton": ""
//         },
//         "options": {
//             "optionSeperator": "",
//             "items": {
//                 "1": {
//                     "imageRef": "",
//                     "bodyText": "",
//                     "text": "",
//                     "next": "newStepValue"
//                 }
//             },
//             "keywords": {
//                 "1": []
//             }
//         },
//         "results": {
//             "default": {
//                 "next": "OPTIONAL"
//             }
//         }
//     },
//     "type": "menu",
//     "next": "_MENU_END_",
//     "metadata": {}
// }